import styled from '../../theme/styled-with-theme';
import { Column } from '../Layout';

export const HeroCopyColumn = styled(Column)`
  padding: 0;
`;
